module.exports = __webpack_public_path__ + "img/图片5.bb4106b9.png";